/**
 * Mardo Cigars — Brian Tracking
 * First-touch UTM capture + cart attribute sync.
 *
 * Loaded with `defer` from layout/theme.liquid. Runs once per page load:
 *   1. Reads UTM params from URL → saves to localStorage as first-touch
 *   2. Pushes UTMs to cart attributes (mardo_utm_*) for checkout attribution
 *   3. Re-syncs on click of any element that looks like "checkout"
 */
(function () {
  var STORAGE_KEY = 'mardo_first_touch_utm';
  var CART_SENT_KEY = 'mardo_cart_utm_synced';
  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];

  function getUrlUtms() {
    var url = new URL(window.location.href);
    var data = {};

    UTM_KEYS.forEach(function (key) {
      var value = url.searchParams.get(key);
      if (value && value.trim() !== '') {
        data[key] = value.trim();
      }
    });

    return data;
  }

  function safeParse(json) {
    try {
      return JSON.parse(json);
    } catch (e) {
      return {};
    }
  }

  function saveFirstTouchIfNeeded() {
    var incoming = getUrlUtms();
    if (!Object.keys(incoming).length) return;

    var existing = safeParse(localStorage.getItem(STORAGE_KEY) || '{}');

    if (!existing.utm_source) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(incoming));
      sessionStorage.removeItem(CART_SENT_KEY);
    }
  }

  function getStoredUtm() {
    return safeParse(localStorage.getItem(STORAGE_KEY) || '{}');
  }

  function buildCartAttributes(utm) {
    return {
      mardo_utm_source: utm.utm_source || '',
      mardo_utm_medium: utm.utm_medium || '',
      mardo_utm_campaign: utm.utm_campaign || '',
      mardo_utm_content: utm.utm_content || '',
      mardo_utm_term: utm.utm_term || ''
    };
  }

  function hasUsefulUtm(utm) {
    return !!(utm && (utm.utm_source || utm.utm_medium || utm.utm_campaign || utm.utm_content || utm.utm_term));
  }

  function syncUtmToCart() {
    var utm = getStoredUtm();
    if (!hasUsefulUtm(utm)) return;

    if (sessionStorage.getItem(CART_SENT_KEY) === '1') return;

    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        attributes: buildCartAttributes(utm)
      })
    })
    .then(function (res) {
      if (!res.ok) throw new Error('Cart update failed');
      return res.json();
    })
    .then(function () {
      sessionStorage.setItem(CART_SENT_KEY, '1');
      console.log('[Mardo UTM] UTM sincronizado al carrito');
    })
    .catch(function (err) {
      console.error('[Mardo UTM] Error sincronizando carrito:', err);
    });
  }

  saveFirstTouchIfNeeded();
  syncUtmToCart();

  document.addEventListener('click', function (e) {
    var target = e.target.closest('a, button, input[type="submit"]');
    if (!target) return;

    var text = (target.innerText || target.value || '').toLowerCase();
    var href = (target.getAttribute('href') || '').toLowerCase();
    var name = (target.getAttribute('name') || '').toLowerCase();

    var looksLikeCheckout =
      href.indexOf('/checkout') !== -1 ||
      text.indexOf('checkout') !== -1 ||
      text.indexOf('pagar') !== -1 ||
      text.indexOf('finalizar') !== -1 ||
      name.indexOf('checkout') !== -1;

    if (looksLikeCheckout) {
      syncUtmToCart();
    }
  });
})();
